<template>
  <v-data-table
    height="55vh"
    fixed-header
    :headers="headers"
    :items="this.$store.state.quesData"
    :search="search"
    sort-by="rowId"
    class="elevation-1"
  >
    <!-- <template v-slot:item.questUrl="{ item }"> -->
    <template v-slot:[`item.questUrl`]="{ item }">
      <v-btn color="primary" @click="copyUrl(item.questUrl)">
        複製連結
        <!-- <a
          v-bind:value="item.questUrl"
          style="color:#FFF; text-decoration:none;font-size:18px"
          >複製連結</a
        > -->
      </v-btn>
    </template>
    <!-- <template v-slot:item.questQRCode="{ item }"> -->
    <template v-slot:[`item.questQRCode`]="{ item }">
      <v-btn class="primary" @click="dialogViewOpen(item.questQRCode)">檢視</v-btn>
      <!-- <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-icon
        small
        class="mr-2"
        style="font-size: 32px"
        dark v-on="on"
        color="#777777"
      >mdi-eye</v-icon>        
      </template>
      <img v-bind:src="'data:image/jpeg;base64,'+item.QRCode" style="width:100px" />  
      </v-tooltip>-->
    </template>
    <template v-slot:top>
      <div class="pa-5">
        <div class="row viewList">
          <div class="col-sm-12 col-md-4 col-lg-2">
            <!-- :hint="`選單功能, ${select.value}`" -->
            <v-select
              v-model="selectQ"
              :items="$store.state.questCmb"
              item-text="name"
              item-value="value"
              persistent-hint
              return-object
              single-line
            ></v-select>
            <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
            <v-text-field
              v-model="queryCon"
              v-bind:label="selectQ.placeholder"
              single-line
              hide-details
              placeholder="請先選擇查詢類型"
            ></v-text-field>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-2">
            <!-- :hint="`選單功能, ${select.value}`" -->
            <v-select
              v-model="selectP"
              :items="$store.state.publicType"
              item-text="name"
              item-value="value"
              persistent-hint
              return-object
              single-line
            ></v-select>
            <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
          </div>
          <!-- <div style="">
            <date-pick v-model="date"></date-pick>
          </div>
          {{date}}{{dates}} -->
          <div class="col-sm-12 col-md-4 col-lg-2">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="dates"
              persistent
              width="290px"
            >
              <!-- 手動輸入日期 -->
              <div class="pa-2" style="background-color: #fff">
                <v-text-field
                  label="填寫日期"
                  prepend-icon="event"
                  v-model="dateRangeTextInput"
                  :placeholder="dateRangeText"
                  @keyup="textInputDate"
                  @click="getDateRang"
                ></v-text-field>
              </div>
              <template v-slot:activator="{ on }">
                <v-text-field
                  slot-scope
                  v-model="dateRangeText"
                  label="填寫時間"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                locale="zh-tw"
                selected-items-text="已選擇兩個日期"
                range
                @change="clearTextInput"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">取消</v-btn>
                <!-- <v-btn text color="primary" @click="$refs.dialog.save(dates)">確認</v-btn> -->
                <v-btn text color="primary" @click="saveDates(dates)">確認</v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-1">
            <v-btn
              large
              color="primary"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="query(true)"
              >查詢</v-btn
            >
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-dialog v-model="dialogView" max-width="350px">
              <v-card>
                <v-card-title>{{ quesDialogTitle }}</v-card-title>

                <v-card-text>
                  <v-container
                    ><qrcode v-bind:value="questQRCode" :options="{ width: 200 }"></qrcode
                  ></v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">關閉</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:no-data></template>
  </v-data-table>
</template>
<script>
// import DatePick from 'vue-date-pick'
// import 'vue-date-pick/dist/vueDatePick.css'
export default {
  // components: { DatePick },
  mounted() {
    this.$store.state.quesData = []
  },
  created() {
    this.$store.commit('getDate')
    this.dates[0] = this.$store.state.date.current
    this.dates[1] = this.$store.state.date.nextMonth
    this.query(false)
  },
  data() {
    return {
      valid: true,
      search: '',
      queryCon: '',
      dialog: false,
      dialogView: false,
      disabled: false,
      questQRCode: '',
      quesDialogTitle: '',
      selectQ: { name: '問卷查詢條件', value: null, placeholoder: '請先選擇查詢條件' },
      selectP: { name: '問卷公開狀態', value: null, placeholoder: '' },

      useTypeItem: ['正常使用', '暫停使用', '不再使用'],
      headers: [
        //{ text: '', value: 'rowId', sortable: false },
        { text: '問卷編號', value: 'questSysId' },
        { text: '問卷名稱', value: 'questTitle' },
        { text: '問卷連結', value: 'questUrl' },
        { text: 'QRCode', value: 'questQRCode' },
        { text: '回覆數', value: 'questNowNum' },
        { text: '限定份數', value: 'questMaxNum' },
        { text: '指定人員回覆數', value: 'questNowNumCM' },
        { text: '公開狀態', value: 'isVisible.name' },
        { text: '起始日期', value: 'questDateStart' },
        { text: '結束日期', value: 'questDateEnd' },
      ],
      //日期
      dates: ['', ''],
      dateRangeTextInput: '',
      menu: false,
      modal: false,
      menu2: false,
    }
  },
  methods: {
    close() {
      this.disabled = false
      this.dialogView = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    dialogViewOpen(item) {
      this.questQRCode = item
      this.quesDialogTitle = 'QRCode'
      this.dialogView = true
    },
    copyUrl(url) {
      var copyEle = document.createElement('textarea')
      document.body.appendChild(copyEle)
      copyEle.value = url
      copyEle.select()
      document.execCommand('copy')
      document.body.removeChild(copyEle)
    },
    query(isDate) {
      //先把store舊的清掉
      this.$store.state.quesData.splice(0)
      //分割日期字串
      const str = this.dateRangeText.replace(/\s/g, '')
      const dateTime = str.split('~')

      let url = this.$store.state.api + '/Q01005/query'
      let data = Object.assign(
        { queryType: this.selectQ },
        { queryCon: this.queryCon },
        { publicType: this.selectP },
        { strDate: isDate === true ? dateTime[0] : '' },
        { endDate: isDate === true ? dateTime[1] : '' }
      )
      this.axios.post(url, this.qs.stringify(data)).then((res) => {
        if (res.data.resultCode == '10') {
          res.data.rows.forEach((row) => {
            row.questQRCode = row.questUrl =
              this.$store.state.server + 'user/answer?questSysId=' + row.questSysId
            row.isVisible = {
              name: row.isVisible === '01' ? '公開' : '不公開',
              value: row.isVisible,
            }
            window.console.log(row)
            this.$store.state.quesData.push(row)
          })
        } else {
          alert(res.data.error)
        }
      })
    },
    swapDate() {
      let tmp = this.dates[0]
      this.dates[0] = this.dates[1]
      this.dates[1] = tmp
    },
    getDateRang() {
      this.dateRangeTextInput = this.dateRangeText
    },
    textInputDate() {
      const str = this.dateRangeTextInput.replace(/\s/g, '')
      this.dates = str.split('~')
    },
    clearTextInput() {
      this.dateRangeTextInput = ''
    },
    saveDates(dates) {
      //判斷有~連接
      if (this.dateRangeText.indexOf('~') != -1) {
        //只能是數字
        const reg = /(\d+)-(\d+)-(\d+)/
        const matched1 = dates[0].match(reg)
        const matched2 = dates[1].match(reg)
        let YYYY = [0, 0]
        let MM = [0, 0]
        let DD = [0, 0]
        if (matched1 && matched2) {
          //字數判定日期格式
          let dateStart = dates[0].split('-')
          let dateEnd = dates[1].split('-')
          let year = [dateStart[0], dateEnd[0]]
          let month = [dateStart[1], dateEnd[1]]
          let date = [dateStart[2], dateEnd[2]]
          for (let i = 0; i < year.length; i++) {
            YYYY[i] = (0 < year[i]) + (year[i] < 10000) //=>2 1~9999年
            MM[i] = (0 < month[i]) + (month[i] < 13) //=>2 1~12月
            DD[i] = 0

            //判斷日期天數
            let dateRangCase = 0
            if (month[i] == 2) {
              if (month[i] % 4 == 0) {
                dateRangCase = 0 //閏年2月 29天
              } else {
                dateRangCase = 1 //非潤2月 28天
              }
            } else {
              if (1 <= month[i] && month[i] <= 7) {
                //1~7月 非2月
                if (month[i] % 2 == 0) {
                  dateRangCase = 2 //30天
                } else {
                  dateRangCase = 3 //31天
                }
              } else {
                // 8~12月
                if (month[i] % 2 == 0) {
                  dateRangCase = 3 //31天
                } else {
                  dateRangCase = 2 //30天
                }
              }
            }
            switch (dateRangCase) {
              case 0:
                DD[i] = (0 < date[i]) + (date[i] < 30) //29天
                break
              case 1:
                DD[i] = (0 < date[i]) + (date[i] < 29) //28天
                break
              case 2:
                DD[i] = (0 < date[i]) + (date[i] < 31) //30天
                break
              case 3:
                DD[i] = (0 < date[i]) + (date[i] < 32) //31天
                break
            }
          }
          let datesConfirm = YYYY[0] + YYYY[1] + MM[0] + MM[1] + DD[0] + DD[1]
          if (datesConfirm == 12) {
            this.$refs.dialog.save(dates)
            window.console.log(dates)
          } else {
            alert('日期格式錯誤!')
          }
        } else {
          alert('請以數字輸入日期!')
        }
      }else{
        alert('請以"~"連接先後日期!')
      }
    },
  },
  computed: {
    dateRangeText() {
      if (
        this.dates.length === 2 &&
        Date.parse(this.dates[0]) > Date.parse(this.dates[1])
      ) {
        this.swapDate()
      }
      return this.dates.join(' ~ ')
    },
  },
}
</script>

<style>
.v-text-field label {
  font-size: 2em;
}
.v-data-table td {
  font-size: 0.7rem;
  height: 48px;
}
.v-application a {
  color: #000;
}
.vdp-datepicker input {
  width: 75px;
  height: 20px;
}
.v-picker {
  height: 500px;
}
</style>
